// Gemeinsame Upload-Helfer für Chat-Seite und Widget.

export const IMAGE_EXTS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'heic']
export const DOC_EXTS = ['pdf', 'docx', 'xlsx', 'txt', 'csv', 'md', 'json']
export const MAX_UPLOAD_BYTES = 20 * 1024 * 1024
const MAX_IMAGE_EDGE = 1800 // hält Bilder unter dem 2000px-Limit der Claude-CLI

function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

// Bild laden und – falls grösser als MAX_IMAGE_EDGE – im Browser verkleinern.
// Verhindert, dass grosse Screenshots/Fotos die Claude-Session sprengen.
// Gibt { media_type, data (base64 ohne Prefix), filename } zurück.
export async function prepareImageForUpload(file) {
  const ext = file.name.split('.').pop()?.toLowerCase()
  const dataUrl = await fileToDataUrl(file)

  // HEIC kann der Browser nicht zuverlässig in <img> decodieren → unverändert durchreichen.
  if (ext === 'heic') {
    return { media_type: 'image/heic', data: dataUrl.split(',')[1], filename: file.name }
  }

  const img = await new Promise((resolve, reject) => {
    const im = new Image()
    im.onload = () => resolve(im)
    im.onerror = reject
    im.src = dataUrl
  }).catch(() => null)

  // Konnte nicht decodiert werden → Original senden
  if (!img || !img.width || !img.height) {
    const media_type = ext === 'jpg' || ext === 'jpeg' ? 'image/jpeg' : `image/${ext}`
    return { media_type, data: dataUrl.split(',')[1], filename: file.name }
  }

  if (img.width <= MAX_IMAGE_EDGE && img.height <= MAX_IMAGE_EDGE) {
    const media_type = ext === 'jpg' || ext === 'jpeg' ? 'image/jpeg' : `image/${ext}`
    return { media_type, data: dataUrl.split(',')[1], filename: file.name }
  }

  const scale = MAX_IMAGE_EDGE / Math.max(img.width, img.height)
  const w = Math.round(img.width * scale)
  const h = Math.round(img.height * scale)
  const canvas = document.createElement('canvas')
  canvas.width = w
  canvas.height = h
  canvas.getContext('2d').drawImage(img, 0, 0, w, h)
  const out = canvas.toDataURL('image/jpeg', 0.9)
  return { media_type: 'image/jpeg', data: out.split(',')[1], filename: file.name }
}

// Dateiname für den Platten-Upload eines vorbereiteten Bildes. Die Endung muss
// zum (evtl. nach Verkleinerung geänderten) media_type passen, damit read_chat_file
// das Bild korrekt als Vision liest.
const IMAGE_EXT_BY_TYPE = {
  'image/jpeg': 'jpg', 'image/png': 'png', 'image/gif': 'gif',
  'image/webp': 'webp', 'image/heic': 'heic'
}
export function imageUploadName(img, originalName) {
  const ext = IMAGE_EXT_BY_TYPE[img.media_type] || 'jpg'
  return (originalName || 'bild').replace(/\.[^.]+$/, '') + '.' + ext
}
